<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="notification.projectName"
    class="notification__item"
  >
    <template #pic>
      <div class="label-pic is-green">
        <icon
          data="@icon/team-add.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        There's a New Team for you
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        You’ve been added to
        <a
          :href="notification.acceptanceUrl"
          class="link .is-medium-500"
          >Team {{ notification.teamName }}</a
        >
        at {{ notification.companyName }}.
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationTeamAddition } from "@/models/Notification"

@Options({
  name: "TEAM_ADDITION",
  components: {
    NotificationTemplate
  }
})
export default class TEAM_ADDITION extends Vue {
  @Prop() readonly notification: NotificationTeamAddition
}
</script>
